import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfPoint,
  PdfRect,
  PdfFont,
  PdfBrush,
  ETextAlign,
} from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/label';
import '../../pdf/draw/cut';

/**
 * Dvirka (Two-Column Fold-Over Exercise)
 *
 * Layout: Landscape page split in half vertically.
 * Left half: questions in grid cells. Right half: answers.
 * Cut marks at the fold line so the page can be folded.
 *
 * Migrated from C# EduFrame.Single.Generators.Dvirka
 */
export class Dvirka implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 12;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage(true); // landscape

    const margin = PdfUnit.FromMillimeters(5);
    const halfWidth = PdfSize.A4H.width / 2 - margin;
    const fullHeight = PdfSize.A4H.height - 2 * margin;

    const left = new PdfRect(margin, margin, halfWidth, fullHeight);
    const right = new PdfRect(left.right, margin, halfWidth, fullHeight);

    const count = opts.list.length;
    if (count === 0) return;

    const items = opts.list.slice(0, count);

    page.drawLine(
      GUtil.cutPen,
      new PdfPoint(left.right, 0),
      new PdfPoint(left.right, PdfSize.A4H.height)
    );

    const sizeWidth = PdfUnit.FromMillimeters(30);
    const sizeHeight = left.height / count;
    const cellWidth = left.width - sizeWidth;

    const leftHead = new PdfRect(left.x, left.y, sizeWidth, left.height);
    const rightHead = new PdfRect(right.x, right.y, sizeWidth, right.height);
    page.drawRectangle(GUtil.basePen, null, leftHead);
    page.drawRectangle(GUtil.basePen, null, rightHead);

    const cellSize = new PdfSize(cellWidth, sizeHeight);
    const leftTexts = items.map((t) => t.left.getText()).filter((t) => t);
    const rightTexts = items.map((t) => t.right.getText()).filter((t) => t);
    const leftFont =
      leftTexts.length > 0
        ? page.adjustFontMulti(
            leftTexts.map((t) => [t]),
            GUtil.baseFont,
            cellSize
          )
        : GUtil.baseFont;
    const rightFont =
      rightTexts.length > 0
        ? page.adjustFontMulti(
            rightTexts.map((t) => [t]),
            GUtil.baseFont,
            cellSize
          )
        : GUtil.baseFont;

    for (let i = 0; i < count; i++) {
      const rectLeft = new PdfRect(
        left.x + sizeWidth,
        left.y + sizeHeight * i,
        cellWidth,
        sizeHeight
      );
      const rectRight = new PdfRect(
        right.x + sizeWidth,
        left.y + sizeHeight * i,
        cellWidth,
        sizeHeight
      );

      page.drawLabel(items[i].left, { rect: rectLeft, font: leftFont });
      page.drawLabel(items[i].right, { rect: rectRight, font: rightFont });

      page.drawRectangle(GUtil.cutPen, null, rectLeft);
      page.drawRectangle(GUtil.cutPen, null, rectRight);
    }
  }
}
